function ErrorPage(props) {
    const { msg } = props;

    return (
        <div className='error-page-overlay'>
            <div class='error-page-content'>
                <label class='error-page-content-text'>{ `${msg}` }</label>
            </div>
        </div>
    );

};


export default ErrorPage;